"use client";

import type { VisualCmsSection } from "@/types/visual-cms";
import { VISUAL_CMS_SECTION_TYPE_LABELS } from "@/types/visual-cms";
import { SECTION_CONTAINER, sectionShellStyle } from "./section-shell";

interface PlaceholderSectionProps {
  section: VisualCmsSection;
}

/**
 * Placeholder render for section types that don't have a bespoke renderer yet
 * (timeline, trust_blocks, guidelines, etc.). Kept as a visible block so the
 * admin still sees where the section will land on the page.
 */
export function PlaceholderSection({ section }: PlaceholderSectionProps) {
  const shell = sectionShellStyle(section);
  const label =
    VISUAL_CMS_SECTION_TYPE_LABELS[section.section_type] ?? section.section_type;

  return (
    <section className={shell.className} style={shell.style}>
      <div className={SECTION_CONTAINER}>
        <div className="rounded-lg border border-dashed border-gray-300 bg-white/50 px-6 py-10 text-center">
          <p className="text-sm font-semibold uppercase tracking-wider text-current/60">
            {label} section
          </p>
          <p className="mt-2 text-xs text-current/50">
            Renderer not built yet — generic content saved as JSON. A bespoke design ships in a
            later phase.
          </p>
        </div>
      </div>
    </section>
  );
}
